const iconPath = process.env.PUBLIC_URL + '/images/icons/';

const commonArea = iconPath + 'commonArea.svg',
  creativeArts = iconPath + 'creativeArts.svg',
  informationTechnology = iconPath + 'informationTechnology.svg',
  engineeringConstruction = iconPath + 'engineeringConstruction.svg',
  culinary = iconPath + 'culinary.svg',
  skilledTrades = iconPath + 'skilledTrades.svg',
  transportationTechnology = iconPath + 'transportationTechnology.svg',
  accessibility = iconPath + 'accessibility.svg',
  aed = iconPath + 'aed.svg',
  amenities = iconPath + 'amenities.svg',
  atm = iconPath + 'atm.svg',
  bikeRack = iconPath + 'bikeRack.svg',
  campusStore = iconPath + 'campusStore.svg',
  computerLab = iconPath + 'computerLab.svg',
  deliveries = iconPath + 'deliveries.svg',
  dieselParking = iconPath + 'dieselParking.svg',
  directions = iconPath + 'directions.svg',
  elevator = iconPath + 'elevator.svg',
  entranceContractor = iconPath + 'entranceContractor.svg',
  entranceEast = iconPath + 'entranceEast.svg',
  entranceMain = iconPath + 'entranceMain.svg',
  entranceNorth = iconPath + 'entranceNorth.svg',
  entranceWest = iconPath + 'entranceWest.svg',
  evCharge = iconPath + 'evCharge.svg',
  fitnessCentre = iconPath + 'fitnessCentre.svg',
  food = iconPath + 'food.svg',
  handicapParking = iconPath + 'handicapParking.svg',
  healthCentre = iconPath + 'healthCentre.svg',
  healthSciences = iconPath + 'healthSciences.svg',
  indigenousSupports = iconPath + 'indigenousSupports.svg',
  indigenousEducation = iconPath + 'indigenousEducation.svg',
  information = iconPath + 'information.svg',
  library = iconPath + 'library.svg',
  medicineWheel = iconPath + 'indigenousSupports.svg',
  motorcycleParking = iconPath + 'motorcycleParking.svg',
  musterPoint = iconPath + 'musterPoint.svg',
  parking = iconPath + 'parking.svg',
  payParking = iconPath + 'payParking.svg',
  reflectionRoom = iconPath + 'reflectionRoom.svg',
  residence = iconPath + 'residence.svg',
  rrcsa = iconPath + 'rrcsa.svg',
  security = iconPath + 'security.svg',
  spectrum = iconPath + 'spectrum.svg',
  studentServices = iconPath + 'studentServices.svg',
  washroom = iconPath + 'washroom.svg',
  wheelchairLift = iconPath + 'wheelchairLift.svg';

const markers = {
  accessibility: {
    name: 'Accessibility', // category group name
    icon: accessibility,
    items: [
      {
        id: 'elevator1',
        icon: elevator,
        lat: 49.91823,
        lng: -97.21195,
        info: 'Elevator - Building C',
      },
      {
        id: 'elevator2',
        icon: elevator,
        lat: 49.917959,
        lng: -97.21044,
        info: 'Elevator - Building A',
      },
      {
        id: 'elevator3',
        icon: elevator,
        lat: 49.917877,
        lng: -97.212303,
        info: 'Elevator - Building D',
      },
      {
        id: 'elevator4',
        icon: elevator,
        lat: 49.918657,
        lng: -97.212303,
        info: 'Elevator - Building F',
      },
      {
        id: 'elevator5',
        icon: elevator,
        lat: 49.91968,
        lng: -97.208384,
        info: 'Elevator',
      },
      {
        id: 'elevator6',
        icon: elevator,
        lat: 49.900193,
        lng: -97.141791,
        info: 'Elevator - W',
      },
      {
        id: 'elevator7',
        icon: elevator,
        lat: 49.900323,
        lng: -97.141252,
        info: 'Elevator - P',
      },
      {
        id: 'elevator8',
        icon: elevator,
        lat: 49.898818,
        lng: -97.139447,
        info: 'Elevator - PGI',
      },
      {
        id: 'elevator9',
        icon: elevator,
        lat: 49.90099,
        lng: -97.141513,
        info: 'Elevator - Manitou a bi Bii daziigae',
      },
      {
        id: 'accessibleParking1',
        icon: handicapParking,
        lat: 49.918265,
        lng: -97.213911,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking2',
        icon: handicapParking,
        lat: 49.919156,
        lng: -97.21015,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking3',
        icon: handicapParking,
        lat: 49.91933,
        lng: -97.20868,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking4',
        icon: handicapParking,
        lat: 49.917198,
        lng: -97.211267,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking5',
        icon: handicapParking,
        lat: 49.91766,
        lng: -97.2095,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking6',
        icon: handicapParking,
        lat: 49.91772,
        lng: -97.213911,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking7',
        icon: handicapParking,
        lat: 49.91886,
        lng: -97.213911,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking8',
        icon: handicapParking,
        lat: 49.91903,
        lng: -97.21296,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking9',
        icon: handicapParking,
        lat: 49.91947,
        lng: -97.21108,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking10',
        icon: handicapParking,
        lat: 49.91878,
        lng: -97.21067,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking11',
        icon: handicapParking,
        lat: 49.91857,
        lng: -97.20816,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking12',
        icon: handicapParking,
        lat: 49.92033,
        lng: -97.21033,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking13',
        icon: handicapParking,
        lat: 49.92059,
        lng: -97.20941,
        info: 'Accessible Parking',
      },
      {
        id: 'wheelchairLift1',
        icon: wheelchairLift,
        lat: 49.917695,
        lng: -97.21019,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift2',
        icon: wheelchairLift,
        lat: 49.918881,
        lng: -97.210378,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift3',
        icon: wheelchairLift,
        lat: 49.920353,
        lng: -97.209455,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift4',
        icon: wheelchairLift,
        lat: 49.918886,
        lng: -97.211808,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift5',
        icon: wheelchairLift,
        lat: 49.918912,
        lng: -97.2123,
        info: 'Wheelchair Lift',
      },
      {
        id: 'accessibleEntrance1',
        icon: accessibility,
        lat: 49.91867,
        lng: -97.213412,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance2',
        icon: accessibility,
        lat: 49.917907,
        lng: -97.213392,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance3',
        icon: accessibility,
        lat: 49.918845,
        lng: -97.212451,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance4',
        icon: accessibility,
        lat: 49.91775,
        lng: -97.212204,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance5',
        icon: accessibility,
        lat: 49.917827,
        lng: -97.211526,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance6',
        icon: accessibility,
        lat: 49.917979,
        lng: -97.21018,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance7',
        icon: accessibility,
        lat: 49.91828,
        lng: -97.21029,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance8',
        icon: accessibility,
        lat: 49.918737,
        lng: -97.21041,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance9',
        icon: accessibility,
        lat: 49.919256,
        lng: -97.209322,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance10',
        icon: accessibility,
        lat: 49.91952,
        lng: -97.20828,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance11',
        icon: accessibility,
        lat: 49.92046,
        lng: -97.209353,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance12',
        icon: accessibility,
        lat: 49.92015,
        lng: -97.210418,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance13',
        icon: accessibility,
        lat: 49.900003,
        lng: -97.141905,
        info: 'Accessible Entrance - William Ave.',
      },
      {
        id: 'accessibleEntrance14',
        icon: accessibility,
        lat: 49.900554,
        lng: -97.141446,
        info: 'Accessible Entrance - Elgin Ave.',
      },
      {
        id: 'accessibleEntrance15',
        icon: accessibility,
        lat: 49.900182,
        lng: -97.14121,
        info: 'Accessible Entrance - Princess St. 1',
      },
      {
        id: 'accessibleEntrance16',
        icon: accessibility,
        lat: 49.899963,
        lng: -97.141366,
        info: 'Accessible Entrance - Princess St. 2',
      },
      {
        id: 'accessibleEntrance17',
        icon: accessibility,
        lat: 49.898881,
        lng: -97.140138,
        info: 'Accessible Entrance - Old Market Square',
      },
      {
        id: 'accessibleEntrance18',
        icon: accessibility,
        lat: 49.8988,
        lng: -97.139367,
        info: 'Accessible Entrance - Main St.',
      },
      {
        id: 'accessibleEntrance19',
        icon: accessibility,
        lat: 49.900896,
        lng: -97.141731,
        info: 'Accessible Entrance - Elgin Ave.',
      },
    ],
  },
  amenities: {
    name: 'Amenities and Facilities',
    icon: amenities,
    items: [
      {
        id: 'atm1',
        icon: atm,
        lat: 49.917955,
        lng: -97.211554,
        info: 'ATM - Mall Level',
      },
      {
        id: 'atm2',
        icon: atm,
        lat: 49.90003,
        lng: -97.141688,
        info: 'ATM - Main Floor',
      },
      {
        id: 'fitnessCentre1',
        icon: fitnessCentre,
        lat: 49.919117,
        lng: -97.212251,
        info: 'Fitness Centre - Mall Level',
      },
      {
        id: 'fitnessCentre2',
        icon: fitnessCentre,
        lat: 49.900651,
        lng: -97.141756,
        info: 'Fitness Centre - Main Floor',
      },
      {
        id: 'healthCentre1',
        icon: healthCentre,
        lat: 49.918541,
        lng: -97.211515,
        info: 'Health Centre - Mall Level',
      },
      {
        id: 'residence1',
        icon: residence,
        lat: 49.898894,
        lng: -97.139647,
        info: 'Student Residence - Floors 4-10',
      },
      {
        id: 'campusStore1',
        icon: campusStore,
        lat: 49.917805,
        lng: -97.211554,
        info: 'Campus Store - Mall Level',
      },
      {
        id: 'campusStore2',
        icon: campusStore,
        lat: 49.900031,
        lng: -97.14155,
        info: 'Campus Store - Main Floor',
      },
      {
        id: 'library1',
        icon: library,
        lat: 49.89999,
        lng: -97.141588,
        info: 'Library - Second Floor',
      },
      {
        id: 'library2',
        icon: library,
        lat: 49.918225,
        lng: -97.212321,
        info: 'Library - Mall Level',
      },
      {
        id: 'reflectionRoom1',
        icon: reflectionRoom,
        lat: 49.917879,
        lng: -97.210883,
        info: 'Reflection Room - Second Floor',
      },
      {
        id: 'reflectionRoom2',
        icon: reflectionRoom,
        lat: 49.900323,
        lng: -97.141356,
        info: 'Reflection Room - Second Floor',
      },
      {
        id: 'spectrum',
        icon: spectrum,
        lat: 49.918622,
        lng: -97.213292,
        info: 'The Spectrum - Mall Level',
      },
      {
        id: 'computerLab1',
        icon: computerLab,
        lat: 49.917879,
        lng: -97.21103,
        info: 'Computer Lab - Second Floor',
      },
      {
        id: 'computerLab2',
        icon: computerLab,
        lat: 49.918058,
        lng: -97.210957,
        info: 'Computer Lab - Fourth Floor',
      },
      {
        id: 'computerLab3',
        icon: computerLab,
        lat: 49.918524,
        lng: -97.210674,
        info: 'Computer Lab - Main Floor',
      },
      {
        id: 'computerLab4',
        icon: computerLab,
        lat: 49.919624,
        lng: -97.210399,
        info: 'Computer Lab - Main Floor',
      },
      {
        id: 'computerLab5',
        icon: computerLab,
        lat: 49.919908,
        lng: -97.210426,
        info: 'Computer Lab - Second Floor',
      },
      {
        id: 'computerLab6',
        icon: computerLab,
        lat: 49.919701,
        lng: -97.209381,
        info: 'Computer Lab - Second Floor',
      },
      {
        id: 'computerLab7',
        icon: computerLab,
        lat: 49.91866,
        lng: -97.212486,
        info: 'Computer Lab - Mall Level/Main Floor',
      },
      {
        id: 'computerLab8',
        icon: computerLab,
        lat: 49.91866,
        lng: -97.213056,
        info: 'Computer Lab - Second Floor',
      },
      {
        id: 'computerLab9',
        icon: computerLab,
        lat: 49.918495,
        lng: -97.213319,
        info: 'Computer Lab - Second Floor',
      },
      {
        id: 'computerLab10',
        icon: computerLab,
        lat: 49.918295,
        lng: -97.213319,
        info: 'Computer Lab - Second Floor',
      },
      {
        id: 'computerLab11',
        icon: computerLab,
        lat: 49.918095,
        lng: -97.213319,
        info: 'Computer Lab - Second Floor',
      },
      {
        id: 'computerLab12',
        icon: computerLab,
        lat: 49.917892,
        lng: -97.213118,
        info: 'Computer Lab - Second/Third Floor',
      },
      {
        id: 'computerLab13',
        icon: computerLab,
        lat: 49.917892,
        lng: -97.212518,
        info: 'Computer Lab - Third Floor',
      },
      {
        id: 'computerLab14',
        icon: computerLab,
        lat: 49.900604,
        lng: -97.141602,
        info: 'Computer Lab - Main Floor',
      },
      {
        id: 'computerLab15',
        icon: computerLab,
        lat: 49.900429,
        lng: -97.141747,
        info: 'Computer Lab - Second/Third Floor',
      },
      {
        id: 'computerLab16',
        icon: computerLab,
        lat: 49.900522,
        lng: -97.141282,
        info: 'Computer Lab - Third/Fourth Floor',
      },
      {
        id: 'computerLab17',
        icon: computerLab,
        lat: 49.900216,
        lng: -97.142127,
        info: 'Computer Lab - Third Floor',
      },
      {
        id: 'computerLab18',
        icon: computerLab,
        lat: 49.899908,
        lng: -97.141733,
        info: 'Computer Lab - Learning Commons',
      },
    ],
  },
  parking: {
    name: 'Commuting and Parking',
    icon: parking,
    items: [
      {
        id: 'accessibleParking1',
        icon: handicapParking,
        lat: 49.918265,
        lng: -97.213911,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking2',
        icon: handicapParking,
        lat: 49.919156,
        lng: -97.21015,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking3',
        icon: handicapParking,
        lat: 49.91933,
        lng: -97.20868,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking4',
        icon: handicapParking,
        lat: 49.917198,
        lng: -97.211267,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking5',
        icon: handicapParking,
        lat: 49.91766,
        lng: -97.2095,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking6',
        icon: handicapParking,
        lat: 49.91772,
        lng: -97.213911,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking7',
        icon: handicapParking,
        lat: 49.91886,
        lng: -97.213911,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking8',
        icon: handicapParking,
        lat: 49.91903,
        lng: -97.21296,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking9',
        icon: handicapParking,
        lat: 49.91947,
        lng: -97.21108,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking10',
        icon: handicapParking,
        lat: 49.91878,
        lng: -97.21067,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking11',
        icon: handicapParking,
        lat: 49.91857,
        lng: -97.20816,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking12',
        icon: handicapParking,
        lat: 49.92033,
        lng: -97.21033,
        info: 'Accessible Parking',
      },
      {
        id: 'accessibleParking13',
        icon: handicapParking,
        lat: 49.92059,
        lng: -97.20941,
        info: 'Accessible Parking',
      },
      {
        id: 'parkingLot1',
        label: 'S1',
        lat: 49.91697,
        lng: -97.21075,
        info: 'South Zone 1 Parking Lot (Permit and Daily - Power and Non-Power - PayByPhone: 15547)',
      },
      {
        id: 'parkingLot14',
        label: 'S2',
        lat: 49.91746,
        lng: -97.20926,
        info: 'South Zone 2 Parking Lot (Permit Holders Only - Non-Power)',
      },
      {
        id: 'parkingLot25',
        label: 'S3',
        lat: 49.91697,
        lng: -97.2098656,
        info: 'South Zone 3 Street Parking (Daily Only – PayByPhone 15547)',
      },
      {
        id: 'parkingLot26',
        label: 'S3',
        lat: 49.917135,
        lng: -97.208284,
        info: 'South Zone 3 Street Parking (Daily Only – PayByPhone 15547)',
      },
      {
        id: 'parkingLot2',
        label: 'W1',
        lat: 49.91748,
        lng: -97.21452,
        info: 'West Zone 1 Parking Lot (Daily Only — PayByPhone: 15548)',
      },
      {
        id: 'parkingLot3',
        label: 'W2',
        lat: 49.91826,
        lng: -97.21452,
        info: 'West Zone 2 Parking Lot (Permit Holders Only - Power)',
      },
      {
        id: 'parkingLot4',
        label: 'W3',
        lat: 49.91914,
        lng: -97.21452,
        info: 'West Zone 3 Parking Lot (Permit Holders Only - Power)',
      },
      {
        id: 'parkingLot5',
        label: 'W4',
        lat: 49.92011,
        lng: -97.21452,
        info: 'West Zone 4 Overflow Parking Lot (Permit and Daily - Power - PayByPhone: 15546)',
      },
      {
        id: 'parkingLot6',
        label: 'C1',
        lat: 49.91919,
        lng: -97.21295,
        info: 'Central Zone 1 Parking Lot (Staff Permit Holders Only - Non-Power)',
      },
      {
        id: 'parkingLot7',
        label: 'C2',
        lat: 49.91954,
        lng: -97.212,
        info: 'Central Zone 2 Parking Lot (Staff Permit Holders Only - Power and Non-Power)',
      },
      {
        id: 'parkingLot21',
        label: 'C3',
        lat: 49.91954,
        lng: -97.21103,
        info: 'Cenral Zone 3 Parking Lot (Staff Permit Holders Only - Power)',
      },
      {
        id: 'parkingLot22',
        label: 'C4',
        lat: 49.91887,
        lng: -97.2107,
        info: 'Central Zone 4 Parking Lot (Staff Permit Holders Only - Non-Power)',
      },
      {
        id: 'parkingLot8',
        label: 'C5',
        lat: 49.91926,
        lng: -97.20845,
        info: 'Central Zone 5 Parking Lot (Staff Permit Holders Only - Power)',
      },
      {
        id: 'parkingLot19',
        label: 'C6',
        lat: 49.91856,
        lng: -97.20781,
        info: 'Central Zone 6 Parking Lot (Staff Permit Holders Only - Power)',
      },
      {
        id: 'parkingLot13',
        label: 'N1',
        lat: 49.91939,
        lng: -97.20761,
        info: 'North Zone 1 Parking Lot (Daily Only — PayByPhone: 15536)',
      },
      {
        id: 'parkingLot9',
        label: 'N2',
        lat: 49.92067,
        lng: -97.20994,
        info: 'North Zone 2 Parking Lot (Permit Holders Only - Power and Non-Power)',
      },
      {
        id: 'parkingLot10',
        label: 'N3',
        lat: 49.92067,
        lng: -97.20825,
        info: 'North Zone 3 Parking Lot (Permit Holders Only - Power and Non-Power)',
      },
      {
        id: 'parkingLot11',
        label: 'N4',
        lat: 49.9214,
        lng: -97.20837,
        info: 'North Zone 4 Parking Lot (Permit Holders Only - Non-Power)',
      },
      {
        id: 'parkingLot12',
        label: 'N5',
        lat: 49.92225,
        lng: -97.20985,
        info: 'North Zone 5 Parking Lot (Permit and Daily - Non-Power - PayByPhone: 15549)',
      },
      {
        id: 'parkingLot15',
        icon: parking,
        lat: 49.90081,
        lng: -97.140945,
        info: 'Parking - Pay Lot',
      },
      {
        id: 'parkingLot16',
        icon: parking,
        lat: 49.9008,
        lng: -97.14418,
        info: 'Parking - Pay Lot',
      },
      {
        id: 'parkingLot17',
        icon: parking,
        lat: 49.89871,
        lng: -97.14106,
        info: 'Parking - Pay Lot',
      },
      {
        id: 'parkingLot18',
        icon: parking,
        lat: 49.898371,
        lng: -97.13995,
        info: 'Parking - Pay Lot',
      },
      {
        id: 'parkingLotACE',
        icon: parking,
        lat: 49.898569,
        lng: -97.14424,
        info: 'Parking - Pay Lot',
      },
      {
        id: 'parkingLot19',
        icon: parking,
        lat: 50.153801,
        lng: -96.890826,
        info: 'Visitor Parking (Two Hours)',
      },
      {
        id: 'parkingLot20',
        icon: parking,
        lat: 50.154503,
        lng: -96.890869,
        info: 'Parking - Pay Lot',
      },
      {
        id: 'motorcycleParking1',
        icon: motorcycleParking,
        lat: 49.918801,
        lng: -97.209163,
        info: 'Motorcycle Parking',
      },
      {
        id: 'paystation3',
        icon: payParking,
        lat: 49.91775,
        lng: -97.21211,
        info: 'Parking Pay Station',
      },
      {
        id: 'paystation4',
        icon: payParking,
        lat: 49.91784,
        lng: -97.20835,
        info: 'Parking Pay Station',
      },
      {
        id: 'paystation6',
        icon: payParking,
        lat: 49.91953,
        lng: -97.20827,
        info: 'Parking Pay Station',
      },
      {
        id: 'paystation7',
        icon: payParking,
        lat: 49.91786,
        lng: -97.21336,
        info: 'Parking Pay Station',
      },
      {
        id: 'dieselParking1',
        icon: dieselParking,
        lat: 49.91957,
        lng: -97.21423,
        info: 'Diesel Parking',
      },
      {
        id: 'dieselParking2',
        icon: dieselParking,
        lat: 49.91982,
        lng: -97.20774,
        info: 'Diesel Parking',
      },
      {
        id: 'evCharge1',
        icon: evCharge,
        lat: 49.91768,
        lng: -97.20975,
        info: 'EV Charging Station (Level 2)',
      },
      {
        id: 'evCharge2',
        icon: evCharge,
        lat: 49.91919,
        lng: -97.20901,
        info: 'EV Charging Station (Level 2)',
      },
      {
        id: 'evCharge6',
        icon: evCharge,
        lat: 49.91944,
        lng: -97.21264,
        info: 'EV Charging Station (Level 1)',
      },
      {
        id: 'evCharge7',
        icon: evCharge,
        lat: 49.91939,
        lng: -97.208179,
        info: 'EV Charging Station (Level 1)',
      },
      {
        id: 'evCharge8',
        icon: evCharge,
        lat: 49.91718,
        lng: -97.21069,
        info: 'EV Charging Station (Level 1)',
      },
      {
        id: 'roadEntrance2',
        icon: entranceEast,
        lat: 49.916495,
        lng: -97.207894,
        info: 'East Entrance - Road Entrance 2',
        cssClassName: 'entranceBottom',
      },
      {
        id: 'roadEntrance3',
        icon: entranceMain,
        lat: 49.916434,
        lng: -97.211621,
        info: 'Main Entrance - Road Entrance 3',
        cssClassName: 'entranceBottom',
      },
      {
        id: 'roadEntrance4',
        icon: entranceWest,
        lat: 49.916415,
        lng: -97.215262,
        info: 'West Entrance - Road Entrance 4',
        cssClassName: 'entranceBottom',
      },
      {
        id: 'roadEntrance5',
        icon: entranceNorth,
        lat: 49.919952,
        lng: -97.20686,
        info: 'North Entrance - Road Entrance 5',
        cssClassName: 'entranceBottom',
      },
      {
        id: 'roadEntrance1',
        icon: entranceContractor,
        lat: 49.919005,
        lng: -97.206859,
        info: 'Contractor Entrance - Road Entrance 1',
        cssClassName: 'entranceBottom',
      },
      {
        id: 'bikeRack1',
        icon: bikeRack,
        lat: 49.91882,
        lng: -97.213459,
        info: 'Bike Rack/Lockers (Locker 25-28)',
      },
      {
        id: 'bikeRack2',
        icon: bikeRack,
        lat: 49.917775,
        lng: -97.213454,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack3',
        icon: bikeRack,
        lat: 49.917701,
        lng: -97.212324,
        info: 'Bike Rack/Lockers (Locker 13-16, 29-34)',
      },
      {
        id: 'bikeRack4',
        icon: bikeRack,
        lat: 49.918245,
        lng: -97.211638,
        info: 'Bike Rack/Lockers (Locker 1-4, 7-12)',
      },
      {
        id: 'bikeRack5',
        icon: bikeRack,
        lat: 49.919109,
        lng: -97.212463,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack7',
        icon: bikeRack,
        lat: 49.919181,
        lng: -97.210451,
        info: 'Bike Rack/Lockers (Locker 21-24)',
      },
      {
        id: 'bikeRack8',
        icon: bikeRack,
        lat: 49.919228,
        lng: -97.209019,
        info: 'Bike Lockers (Locker 17-20)',
      },
      {
        id: 'bikeRack10',
        icon: bikeRack,
        lat: 49.899988,
        lng: -97.142453,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack11',
        icon: bikeRack,
        lat: 49.900798,
        lng: -97.141852,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack12',
        icon: bikeRack,
        lat: 49.900583,
        lng: -97.141418,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack13',
        icon: bikeRack,
        lat: 49.898696,
        lng: -97.140049,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack14',
        icon: bikeRack,
        lat: 49.898611,
        lng: -97.139568,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack15',
        icon: bikeRack,
        lat: 49.918038,
        lng: -97.20959,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack16',
        icon: bikeRack,
        lat: 49.917805,
        lng: -97.20887,
        info: 'Bike Rack',
      },
      {
        id: 'bikeRack17',
        icon: bikeRack,
        lat: 49.917938,
        lng: -97.207225,
        info: 'Bike Rack',
      },
    ],
  },
  deliveries: {
    name: 'Deliveries',
    icon: deliveries,
    items: [
      {
        id: 'informationBooth1',
        icon: information,
        lat: 49.917346,
        lng: -97.211443,
        info: 'Information Booth',
      },
      {
        id: 'securityOffice1',
        icon: security,
        lat: 49.918225,
        lng: -97.211735,
        info: 'Security - Main Floor',
      },
      {
        id: 'securityOffice2',
        icon: security,
        lat: 49.900305,
        lng: -97.141542,
        info: 'Security - Main Floor',
      },
      {
        id: 'securityOffice3',
        icon: security,
        lat: 49.898825,
        lng: -97.139391,
        info: 'Security - Main Floor',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.900366,
        lng: -97.141941,
        info: 'Shipping and Receiving',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.899057,
        lng: -97.139813,
        info: 'Shipping and Receiving',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.92018879967835,
        lng: -97.2127598062162,
        info: 'Delivery Locations - S1, S2, S3',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.91879350948653,
        lng: -97.2112923487328,
        info: 'Shipping and Receiving / Delivery Locations - B7, B8',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.91924396191485,
        lng: -97.21088282571417,
        info: 'Delivery Location - U1',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.91910113599078,
        lng: -97.20989314508584,
        info: 'Delivery Locations - J1',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.918896579057446,
        lng: -97.20985768285958,
        info: 'Delivery Locations - B5, B6',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.91809910765352,
        lng: -97.20984350781296,
        info: 'Delivery Location - P1',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.91846628411105,
        lng: -97.2083586891596,
        info: 'Delivery Locations - B1, B2, B3',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.91873499456493,
        lng: -97.20866716932697,
        info: 'Delivery Location - B4',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.918456221933816,
        lng: -97.20731312763283,
        info: 'Delivery Locations - T2, V1, V2, V3',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.920222457364694,
        lng: -97.20799824405171,
        info: 'Delivery Location - Z1',
      },
      {
        id: 'holder',
        icon: deliveries,
        lat: 49.91924912269398,
        lng: -97.20918717492995,
        info: 'Delivery Location - M1',
      },
    ],
  },
  food: {
    name: 'Food',
    icon: food,
    items: [
      {
        id: 'holder',
        icon: food,
        lat: 49.918216,
        lng: -97.211609,
        info: 'Tim Hortons - Mall Level',
      },
      {
        id: 'holder',
        icon: food,
        lat: 49.918418,
        lng: -97.211017,
        info: 'Voyageur Dining Room - Main Floor',
      },
      {
        id: 'holder',
        icon: food,
        lat: 49.900431,
        lng: -97.141327,
        info: 'Tim Hortons - "Main Floor',
      },
      {
        id: 'holder',
        icon: food,
        lat: 49.899989,
        lng: -97.141625,
        info: 'Grab and Go - Main Floor',
      },
      {
        id: 'holder',
        icon: food,
        lat: 49.899034,
        lng: -97.140067,
        info: 'Culinary Exchange - Main Floor',
      },
      {
        id: 'holder',
        icon: food,
        lat: 49.8987742,
        lng: -97.1394289,
        info: 'Janes - Main Floor',
      },
    ],
  },
  directions: {
    name: 'Getting Around',
    icon: directions,
    items: [
      {
        id: 'wheelchairLift1',
        icon: wheelchairLift,
        lat: 49.917695,
        lng: -97.21019,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift2',
        icon: wheelchairLift,
        lat: 49.918881,
        lng: -97.210378,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift3',
        icon: wheelchairLift,
        lat: 49.920353,
        lng: -97.209455,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift4',
        icon: wheelchairLift,
        lat: 49.918886,
        lng: -97.211808,
        info: 'Wheelchair Lift',
      },
      {
        id: 'wheelchairLift5',
        icon: wheelchairLift,
        lat: 49.918912,
        lng: -97.2123,
        info: 'Wheelchair Lift',
      },
      {
        id: 'accessibleEntrance1',
        icon: accessibility,
        lat: 49.91867,
        lng: -97.213412,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance2',
        icon: accessibility,
        lat: 49.917907,
        lng: -97.213392,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance3',
        icon: accessibility,
        lat: 49.918845,
        lng: -97.212451,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance4',
        icon: accessibility,
        lat: 49.91775,
        lng: -97.212204,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance5',
        icon: accessibility,
        lat: 49.917827,
        lng: -97.211526,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance6',
        icon: accessibility,
        lat: 49.917979,
        lng: -97.21018,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance7',
        icon: accessibility,
        lat: 49.91828,
        lng: -97.21029,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance8',
        icon: accessibility,
        lat: 49.918737,
        lng: -97.21041,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance9',
        icon: accessibility,
        lat: 49.919256,
        lng: -97.209322,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance10',
        icon: accessibility,
        lat: 49.91952,
        lng: -97.20828,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance11',
        icon: accessibility,
        lat: 49.92046,
        lng: -97.209353,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance12',
        icon: accessibility,
        lat: 49.92015,
        lng: -97.210418,
        info: 'Accessible Entrance',
      },
      {
        id: 'accessibleEntrance13',
        icon: accessibility,
        lat: 49.900003,
        lng: -97.141905,
        info: 'Accessible Entrance - William Ave.',
      },
      {
        id: 'accessibleEntrance14',
        icon: accessibility,
        lat: 49.900554,
        lng: -97.141446,
        info: 'Accessible Entrance - Elgin Ave.',
      },
      {
        id: 'accessibleEntrance15',
        icon: accessibility,
        lat: 49.900182,
        lng: -97.14121,
        info: 'Accessible Entrance - Princess St. 1',
      },
      {
        id: 'accessibleEntrance16',
        icon: accessibility,
        lat: 49.899963,
        lng: -97.141366,
        info: 'Accessible Entrance - Princess St. 2',
      },
      {
        id: 'accessibleEntrance17',
        icon: accessibility,
        lat: 49.898881,
        lng: -97.140138,
        info: 'Accessible Entrance - Old Market Square',
      },
      {
        id: 'accessibleEntrance18',
        icon: accessibility,
        lat: 49.8988,
        lng: -97.139367,
        info: 'Accessible Entrance - Main St.',
      },
      {
        id: 'accessibleEntrance19',
        icon: accessibility,
        lat: 49.900896,
        lng: -97.141731,
        info: 'Accessible Entrance - Elgin Ave.',
      },
      {
        id: 'elevator1',
        icon: elevator,
        lat: 49.91823,
        lng: -97.21195,
        info: 'Elevator - Building C',
      },
      {
        id: 'elevator2',
        icon: elevator,
        lat: 49.917959,
        lng: -97.21044,
        info: 'Elevator - Building A',
      },
      {
        id: 'elevator3',
        icon: elevator,
        lat: 49.917877,
        lng: -97.212303,
        info: 'Elevator - Building D',
      },
      {
        id: 'elevator4',
        icon: elevator,
        lat: 49.918657,
        lng: -97.212303,
        info: 'Elevator - Building F',
      },
      {
        id: 'elevator5',
        icon: elevator,
        lat: 49.91968,
        lng: -97.208384,
        info: 'Elevator',
      },
      {
        id: 'elevator6',
        icon: elevator,
        lat: 49.900193,
        lng: -97.141791,
        info: 'Elevator - W',
      },
      {
        id: 'elevator7',
        icon: elevator,
        lat: 49.900323,
        lng: -97.141252,
        info: 'Elevator - P',
      },
      {
        id: 'elevator8',
        icon: elevator,
        lat: 49.898818,
        lng: -97.139447,
        info: 'Elevator - PGI',
      },
      {
        id: 'elevator9',
        icon: elevator,
        lat: 49.90099,
        lng: -97.141513,
        info: 'Elevator - Manitou a bi Bii daziigae',
      },
      {
        id: 'informationBooth1',
        icon: information,
        lat: 49.917346,
        lng: -97.211443,
        info: 'Information Booth',
      },
    ],
  },
  indigenousSupports: {
    name: 'Indigenous Supports',
    icon: indigenousSupports,
    items: [
      {
        id: 'holder',
        icon: medicineWheel,
        lat: 49.920834,
        lng: -97.214433,
        info: 'Medicine Wheel Garden',
      },
      {
        id: 'indigenousCentre1',
        icon: indigenousSupports,
        lat: 49.918695,
        lng: -97.212553,
        info: 'Indigenous Support Centre - Second Floor',
      },
      {
        id: 'indigenousCentre2',
        icon: indigenousSupports,
        lat: 49.900281,
        lng: -97.141272,
        info: 'Indigenous Support Centre - Fourth Floor',
      },
      {
        id: 'roundhouse',
        icon: indigenousSupports,
        lat: 49.901125,
        lng: -97.142267,
        info: 'Roundhouse Auditorium - Second Floor',
      },
      {
        id: 'amikCentre',
        icon: indigenousSupports,
        lat: 49.91785,
        lng: -97.213199,
        info: 'Amik Learning Centre - Second Floor',
      },
    ],
  },
  security: {
    name: 'Safety and Security',
    icon: security,
    items: [
      {
        id: 'informationBooth1',
        icon: information,
        lat: 49.917346,
        lng: -97.211443,
        info: 'Information Booth',
      },
      {
        id: 'securityOffice1',
        icon: security,
        lat: 49.918225,
        lng: -97.211735,
        info: 'Security - Main Floor',
      },
      {
        id: 'securityOffice2',
        icon: security,
        lat: 49.900305,
        lng: -97.141542,
        info: 'Security - Main Floor',
      },
      {
        id: 'securityOffice3',
        icon: security,
        lat: 49.898825,
        lng: -97.139391,
        info: 'Security - Main Floor',
      },
      {
        id: 'securityOffice4',
        icon: security,
        lat: 49.901069,
        lng: -97.141576,
        info: 'Security - Main Floor',
      },
      {
        id: 'musterPoint1',
        icon: musterPoint,
        lat: 49.917965,
        lng: -97.213753,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint2',
        icon: musterPoint,
        lat: 49.918575,
        lng: -97.213761,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint3',
        icon: musterPoint,
        lat: 49.919762,
        lng: -97.213783,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint4',
        icon: musterPoint,
        lat: 49.919223,
        lng: -97.212636,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint5',
        icon: musterPoint,
        lat: 49.918871,
        lng: -97.212338,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint6',
        icon: musterPoint,
        lat: 49.918344,
        lng: -97.212362,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint7',
        icon: musterPoint,
        lat: 49.918176,
        lng: -97.212348,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint8',
        icon: musterPoint,
        lat: 49.91817,
        lng: -97.211519,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint9',
        icon: musterPoint,
        lat: 49.917727,
        lng: -97.211455,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint10',
        icon: musterPoint,
        lat: 49.918918,
        lng: -97.211587,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint11',
        icon: musterPoint,
        lat: 49.919098,
        lng: -97.21059,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint12',
        icon: musterPoint,
        lat: 49.920295,
        lng: -97.210038,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint13',
        icon: musterPoint,
        lat: 49.920613,
        lng: -97.2094,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint14',
        icon: musterPoint,
        lat: 49.920009,
        lng: -97.208991,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint15',
        icon: musterPoint,
        lat: 49.919881,
        lng: -97.207939,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint16',
        icon: musterPoint,
        lat: 49.919402,
        lng: -97.208032,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint17',
        icon: musterPoint,
        lat: 49.918913,
        lng: -97.208057,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint18',
        icon: musterPoint,
        lat: 49.918407,
        lng: -97.207025,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint19',
        icon: musterPoint,
        lat: 49.918962,
        lng: -97.209483,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint20',
        icon: musterPoint,
        lat: 49.918079,
        lng: -97.209715,
        info: 'Muster Point',
      },
      {
        id: 'musterPoint21',
        icon: musterPoint,
        lat: 49.917848,
        lng: -97.21007,
        info: 'Muster Point',
      },
      {
        id: 'aed1',
        icon: aed,
        lat: 49.917968,
        lng: -97.210493,
        info: 'Automated External Defibrillator - Building A (Main Floor)',
      },
      {
        id: 'aed2',
        icon: aed,
        lat: 49.917675,
        lng: -97.210493,
        info: 'Automated External Defibrillator - South Gym (Main Floor)',
      },
      {
        id: 'aed3',
        icon: aed,
        lat: 49.917968,
        lng: -97.210903,
        info: 'Automated External Defibrillator - Building A (Fourth Floor)',
      },
      {
        id: 'aed4',
        icon: aed,
        lat: 49.918585,
        lng: -97.210289,
        info: 'Automated External Defibrillator - Building B (Room B119)',
      },
      {
        id: 'aed5',
        icon: aed,
        lat: 49.918585,
        lng: -97.209436,
        info: 'Automated External Defibrillator - Building B (Room B153)',
      },
      {
        id: 'aed6',
        icon: aed,
        lat: 49.918094,
        lng: -97.211832,
        info: 'Automated External Defibrillator - Building C (Mall Level)',
      },
      {
        id: 'aed7',
        icon: aed,
        lat: 49.918225,
        lng: -97.211795,
        info: 'Automated External Defibrillator - Building C (Main Floor)',
      },
      {
        id: 'aed8',
        icon: aed,
        lat: 49.9182,
        lng: -97.21195,
        info: 'Automated External Defibrillator - Building C (Third/Sixth Floor)',
      },
      {
        id: 'aed9',
        icon: aed,
        lat: 49.917945,
        lng: -97.213258,
        info: 'Automated External Defibrillator - Building D (Main/Second/Third Floor)',
      },
      {
        id: 'aed10',
        icon: aed,
        lat: 49.918274,
        lng: -97.213308,
        info: 'Automated External Defibrillator - Building E (Mall Level)',
      },
      {
        id: 'aed11',
        icon: aed,
        lat: 49.918593,
        lng: -97.213258,
        info: 'Automated External Defibrillator - Building F (Main/Second/Third Floor)',
      },
      {
        id: 'aed12',
        icon: aed,
        lat: 49.919704,
        lng: -97.21033,
        info: 'Automated External Defibrillator - Building J (Main/Second Floor)',
      },
      {
        id: 'aed13',
        icon: aed,
        lat: 49.918985,
        lng: -97.21218,
        info: 'Automated External Defibrillator - North Gym (Mall Level)',
      },
      {
        id: 'aed14',
        icon: aed,
        lat: 49.918561,
        lng: -97.211515,
        info: 'Automated External Defibrillator - Building H - Health Services (Mall Level)',
      },
      {
        id: 'aed15',
        icon: aed,
        lat: 49.919679,
        lng: -97.209423,
        info: 'Automated External Defibrillator - Building M (Second Floor)',
      },
      {
        id: 'aed16',
        icon: aed,
        lat: 49.919665,
        lng: -97.208434,
        info: 'Automated External Defibrillator',
      },
      {
        id: 'aed16',
        icon: aed,
        lat: 49.918308,
        lng: -97.209901,
        info: 'Automated External Defibrillator - CARSI (Main Floor)',
      },
      {
        id: 'aed17',
        icon: aed,
        lat: 49.919248,
        lng: -97.211261,
        info: 'Automated External Defibrillator - Building H (Control Room)',
      },
      {
        id: 'aed18',
        icon: aed,
        lat: 49.900183,
        lng: -97.14152,
        info: 'Automated External Defibrillator - P (Main Floor)',
      },
      {
        id: 'aed19',
        icon: aed,
        lat: 49.9,
        lng: -97.141582,
        info: 'Automated External Defibrillator - P (Fourth Floor)',
      },
      {
        id: 'aed20',
        icon: aed,
        lat: 49.900624,
        lng: -97.141601,
        info: 'Automated External Defibrillator - Fitness Centre (Main Floor)',
      },
      {
        id: 'aed21',
        icon: aed,
        lat: 49.900424,
        lng: -97.1417,
        info: 'Automated External Defibrillator - A (Third Floor)',
      },
      {
        id: 'aed22',
        icon: aed,
        lat: 49.900081,
        lng: -97.142041,
        info: 'Automated External Defibrillator - W (Fourth Floor)',
      },
      {
        id: 'aed23',
        icon: aed,
        lat: 49.898855,
        lng: -97.139391,
        info: 'Automated External Defibrillator (Main Floor)',
      },
      {
        id: 'aed24',
        icon: aed,
        lat: 49.898997,
        lng: -97.139804,
        info: 'Automated External Defibrillator (Third Floor)',
      },
      {
        id: 'aed25',
        icon: aed,
        lat: 49.898754,
        lng: -97.139548,
        info: 'Automated External Defibrillator (Seventh Floor)',
      },
    ],
  },
  studentServices: {
    name: 'Student Services',
    icon: studentServices,
    items: [
      {
        id: 'indigenousCentre1',
        icon: indigenousSupports,
        lat: 49.918695,
        lng: -97.212553,
        info: 'Indigenous Support Centre - Second Floor',
      },
      {
        id: 'indigenousCentre2',
        icon: indigenousSupports,
        lat: 49.900281,
        lng: -97.141272,
        info: 'Indigenous Support Centre - Fourth Floor',
      },
      {
        id: 'studentServices1',
        icon: studentServices,
        lat: 49.917827,
        lng: -97.212303,
        info: 'Student Services (Main Floor)',
      },
      {
        id: 'studentServices2',
        icon: studentServices,
        lat: 49.900198,
        lng: -97.141389,
        info: 'Student Services (Main Floor)',
      },
      {
        id: 'conEd1',
        icon: studentServices,
        lat: 49.918507,
        lng: -97.213313,
        info: 'School of Continuing Education Admissions and Operations (Main Floor)',
      },
      {
        id: 'rrcsa1',
        icon: rrcsa,
        lat: 49.91807,
        lng: -97.212125,
        info: 'RRC Polytech Students Association (Mall Level)',
      },
      {
        id: 'rrcsa2',
        icon: rrcsa,
        lat: 49.900145,
        lng: -97.141633,
        info: 'RRC Polytech Students Association (Main Floor)',
      },
    ],
  },
  washroom: {
    name: 'Washrooms',
    icon: washroom,
    items: [
      {
        id: 'washroom1',
        icon: washroom,
        lat: 49.91823,
        lng: -97.212025,
        info: 'Washroom - Building C (Second-Seventh Floors)',
      },
      {
        id: 'washroom2',
        icon: washroom,
        lat: 49.91797,
        lng: -97.211071,
        info: 'Washroom - Building A (Second-Fourth Floors)',
      },
      {
        id: 'washroom3',
        icon: washroom,
        lat: 49.91797,
        lng: -97.21065,
        info: 'Washroom - Building A (Main Floor)',
      },
      {
        id: 'washroom4',
        icon: washroom,
        lat: 49.917781,
        lng: -97.210395,
        info: 'Washroom - Building A (Mall Level)',
      },
      {
        id: 'washroom5',
        icon: washroom,
        lat: 49.91856,
        lng: -97.21065,
        info: 'Washroom - Building B (Mall Level)',
      },
      {
        id: 'washroom6',
        icon: washroom,
        lat: 49.91856,
        lng: -97.209152,
        info: 'Washroom - Building B (Main Floor)',
      },
      {
        id: 'washroom7',
        icon: washroom,
        lat: 49.917846,
        lng: -97.213115,
        info: 'Washroom - Building D (Main Floor)',
      },
      {
        id: 'washroom8',
        icon: washroom,
        lat: 49.917846,
        lng: -97.21225,
        info: 'Washroom - Building D (Mall Level)',
      },
      {
        id: 'washroom9',
        icon: washroom,
        lat: 49.91793,
        lng: -97.21328,
        info: 'Washroom - Building E (Second/Third Floor)',
      },
      {
        id: 'washroom10',
        icon: washroom,
        lat: 49.918292,
        lng: -97.21345,
        info: 'Washroom - Building E (Mall Level)',
      },
      {
        id: 'washroom11',
        icon: washroom,
        lat: 49.918621,
        lng: -97.21328,
        info: 'Washroom - Building F (Second/Third Floor)',
      },
      {
        id: 'washroom12',
        icon: washroom,
        lat: 49.918646,
        lng: -97.21225,
        info: 'Washroom - Building F (Mall Level)',
      },
      {
        id: 'washroom13',
        icon: washroom,
        lat: 49.919117,
        lng: -97.212151,
        info: 'Washroom - North Gym (Mall Level)',
      },
      {
        id: 'washroom14',
        icon: washroom,
        lat: 49.919455,
        lng: -97.21041,
        info: 'Washroom - Building J (Main/Second Floor)',
      },
      {
        id: 'washroom15',
        icon: washroom,
        lat: 49.920032,
        lng: -97.21041,
        info: 'Washroom - Building J (Main/Second Floor)',
      },
      {
        id: 'washroom16',
        icon: washroom,
        lat: 49.919606,
        lng: -97.208713,
        info: 'Washroom (Main Floor)',
      },
      {
        id: 'washroom17',
        icon: washroom,
        lat: 49.91968,
        lng: -97.20815,
        info: 'Washroom (Second Floor)',
      },
      {
        id: 'washroom18',
        icon: washroom,
        lat: 49.90033,
        lng: -97.141679,
        info: 'Washroom - Atrium (Main Floor)',
      },
      {
        id: 'washroom19',
        icon: washroom,
        lat: 49.900128,
        lng: -97.14209,
        info: 'Washroom (Second - Sixth Floors)',
      },
      {
        id: 'washroom20',
        icon: washroom,
        lat: 49.900423,
        lng: -97.141342,
        info: 'Washroom (Second - Fourth Floors)',
      },
      {
        id: 'washroom21',
        icon: washroom,
        lat: 49.898878,
        lng: -97.13945,
        info: 'Washroom (Basement)',
      },
      {
        id: 'washroom22',
        icon: washroom,
        lat: 49.898818,
        lng: -97.139547,
        info: 'Washroom (Main Floor)',
      },
      {
        id: 'washroom23',
        icon: washroom,
        lat: 49.898933,
        lng: -97.139926,
        info: 'Washroom (Second/Third Floors)',
      },
      {
        id: 'washroom24',
        icon: washroom,
        lat: 49.901,
        lng: -97.141296,
        info: 'Washroom (Basement)',
      },
      {
        id: 'washroom25',
        icon: washroom,
        lat: 49.901109,
        lng: -97.141564,
        info: 'Washroom (First - Fourth Floors)',
      },
    ],
  },
  creativeArts: {
    name: 'Creative Arts',
    icon: creativeArts,
    items: [
      {
        area: 'Radio Station',
        icon: creativeArts,
        lat: 49.900566,
        lng: -97.141853,
        link: 'https://www.rrctours.ca/EDC/CreativeArts/?s=pano132',
      },
      {
        area: 'Foley Studio',
        icon: creativeArts,
        lat: 49.900489,
        lng: -97.141893,
        link: 'https://www.rrctours.ca/EDC/CreativeArts/?s=pano129',
      },
      {
        area: 'Graphic Design Lab',
        icon: creativeArts,
        lat: 49.900066,
        lng: -97.142247,
        link: 'https://www.rrctours.ca/EDC/CreativeArts/?s=pano127',
      },
      {
        area: '3D Lab',
        icon: creativeArts,
        lat: 49.900023,
        lng: -97.142127,
        link: 'https://www.rrctours.ca/EDC/CreativeArts/?s=pano128',
      },
      {
        area: 'TV Studio',
        icon: creativeArts,
        lat: 49.900143,
        lng: -97.142181,
        link: 'https://www.rrctours.ca/EDC/CreativeArts/?s=pano133',
      },
    ],
  },
  commonArea: {
    name: 'Common Area',
    icon: commonArea,
    items: [
      {
        icon: commonArea,
        lat: 49.900267,
        lng: -97.141651,
        area: 'Atrium',
        link: 'https://www.rrctours.ca/EDC/Common/?s=pano127',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.899953,
        lng: -97.141595,
        area: 'Library',
        link: 'https://www.rrctours.ca/EDC/Common/?s=pano155',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.899874,
        lng: -97.141645,
        area: 'Buhler Commons',
        link: 'https://www.rrctours.ca/EDC/Common/?s=pano153',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.898974,
        lng: -97.139714,
        area: 'Residence Double Suite',
        link: 'https://www.rrctours.ca/PGI/Residence/tour.html?startscene=0',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.898843,
        lng: -97.140113,
        area: 'Residence Kitchen',
        link: 'https://www.rrctours.ca/PGI/Residence/tour.html?startscene=2',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.898764,
        lng: -97.140041,
        area: 'Residence Student Lounge',
        link: 'https://www.rrctours.ca/PGI/Residence/tour.html?startscene=3',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.898739,
        lng: -97.139938,
        area: 'Residence Theatre',
        link: 'https://www.rrctours.ca/PGI/Residence/tour.html?startscene=4',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.89896,
        lng: -97.140127,
        area: 'Residence Single Suite',
        link: 'https://www.rrctours.ca/PGI/Residence/tour.html?startscene=5',
        campus: 'edc',
      },
      {
        icon: commonArea,
        lat: 49.917505,
        lng: -97.211686,
        area: 'Bus Loop',
        link: 'https://www.rrctours.ca/NDC/Common/?s=pano236',
        campus: 'ndc',
      },
    ],
  },
  engineeringConstruction: {
    name: 'Engineering and Construction Technology',
    icon: engineeringConstruction,
    items: [
      {
        area: 'Communications Lab',
        icon: engineeringConstruction,
        lat: 49.900651,
        lng: -97.141756,
        link: 'https://www.rrctours.ca/EDC/EET/?s=pano790',
      },
      {
        area: 'Networks Lab',
        icon: engineeringConstruction,
        lat: 49.900489,
        lng: -97.141893,
        link: 'https://www.rrctours.ca/EDC/EET/?s=pano791',
      },
      {
        area: 'Projects Lab',
        icon: engineeringConstruction,
        lat: 49.900604,
        lng: -97.141602,
        link: 'https://www.rrctours.ca/EDC/EET/?s=pano792',
      },
      {
        area: 'Mechanical Engineering Technology - Smart Factory',
        icon: engineeringConstruction,
        lat: 49.918302799643584,
        lng: -97.20891234915152,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=7',
      },
      {
        area: 'Mechanical Engineering Technology - Robotics Lab',
        icon: engineeringConstruction,
        lat: 49.91819377036503,
        lng: -97.20860811845054,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=0',
      },
      {
        area: 'Mechanical Engineering Technology - Materials Lab',
        icon: engineeringConstruction,
        lat: 49.91820767209772,
        lng: -97.20839621768587,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=1',
      },
      {
        area: 'Mechanical Engineering Technology - Metallurgy Lab',
        icon: engineeringConstruction,
        lat: 49.91820767209772,
        lng: -97.20814377938359,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=2',
      },
      {
        area: 'Mechanical Engineering Technology - Electronics Classroom',
        icon: engineeringConstruction,
        lat: 49.918229131239144,
        lng: -97.2089489614064,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=3',
      },
      {
        area: 'Mechanical Engineering Technology - Fluid Power Lab',
        icon: engineeringConstruction,
        lat: 49.91809910765352,
        lng: -97.20840893064691,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=4',
      },
      {
        area: 'Mechanical Engineering Technology - STTC Classroom',
        icon: engineeringConstruction,
        lat: 49.91809910765352,
        lng: -97.20813891526717,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=5',
      },
      {
        area: 'Mechanical Engineering Technology - Computer Lab',
        icon: engineeringConstruction,
        lat: 49.91819377036503,
        lng: -97.20800374061737,
        link: 'https://www.rrctours.ca/STTC/MET/tour.html?startscene=8',
      },
    ],
  },
  informationTechnology: {
    name: 'Information Technology',
    icon: informationTechnology,
    items: [
      {
        area: 'Networking Lab P305',
        icon: informationTechnology,
        lat: 49.900462,
        lng: -97.141107,
        link: 'https://www.rrctours.ca/EDC/BIT/tour.html?startscene=0',
      },
      {
        area: 'Networking Lab P306',
        icon: informationTechnology,
        lat: 49.900402,
        lng: -97.141048,
        link: 'https://www.rrctours.ca/EDC/BIT/tour.html?startscene=1',
      },
    ],
  },
  healthSciences: {
    name: 'Health Sciences',
    icon: healthSciences,
    items: [
      {
        area: 'Veterinary Technology - Laboratory',
        icon: healthSciences,
        lat: 49.9179,
        lng: -97.210312,
        link: 'https://www.rrctours.ca/NDC/Veterinary_Technology/?s=pano958',
      },
      {
        area: 'Veterinary Technology - Surgery Suite',
        icon: healthSciences,
        lat: 49.917928,
        lng: -97.210286,
        link: 'https://www.rrctours.ca/NDC/Veterinary_Technology/?s=pano959',
      },
      {
        area: 'Veterinary Technology - Kennel Rooms',
        icon: healthSciences,
        lat: 49.917957,
        lng: -97.210286,
        link: 'https://www.rrctours.ca/NDC/Veterinary_Technology/?s=pano961',
      },
      {
        area: 'Veterinary Technology - Exam Room',
        icon: healthSciences,
        lat: 49.917878,
        lng: -97.210269,
        link: 'https://www.rrctours.ca/NDC/Veterinary_Technology/?s=pano960',
      },
      {
        area: 'Veterinary Technology - Radiology Room',
        icon: healthSciences,
        lat: 49.917853,
        lng: -97.210266,
        link: 'https://www.rrctours.ca/NDC/Veterinary_Technology/?s=pano962',
      },
      {
        area: 'Medical Radiologic Technology - Lab 4',
        icon: healthSciences,
        lat: 49.917913829196344,
        lng: -97.21070634964067,
        link: 'https://www.rrctours.ca/NDC/Medical_Radiologic_Technology/tour.html?startscene=0',
      },
      {
        area: 'Medical Radiologic Technology - Lab 2',
        icon: healthSciences,
        lat: 49.91792856298261,
        lng: -97.21106331912577,
        link: 'https://www.rrctours.ca/NDC/Medical_Radiologic_Technology/tour.html?startscene=2',
      },
      {
        area: 'Medical Radiologic Technology - Computer Lab',
        icon: healthSciences,
        lat: 49.91786078752861,
        lng: -97.21088483438322,
        link: 'https://www.rrctours.ca/NDC/Medical_Radiologic_Technology/tour.html?startscene=4',
      },
    ],
  },
  culinary: {
    name: 'Culinary',
    icon: culinary,
    items: [
      {
        area: "Jane's",
        icon: culinary,
        lat: 49.898869,
        lng: -97.139411,
        link: 'https://www.rrctours.ca/PGI/Hospitality/?s=pano300',
      },
      {
        area: 'Culinary Exchange',
        icon: culinary,
        lat: 49.899004,
        lng: -97.140037,
        link: 'https://www.rrctours.ca/PGI/Hospitality/?s=pano449',
      },
      {
        area: 'City Bread Professional Baking Lab',
        icon: culinary,
        lat: 49.898964,
        lng: -97.139937,
        link: 'https://www.rrctours.ca/PGI/Hospitality/?s=pano454',
      },
      {
        area: 'Mixology Lab',
        icon: culinary,
        lat: 49.898825,
        lng: -97.140079,
        link: 'https://www.rrctours.ca/PGI/Hospitality/?s=pano635',
      },
      {
        area: 'Apprenticeship Lab',
        icon: culinary,
        lat: 49.8987995,
        lng: -97.139979,
        link: 'https://www.rrctours.ca/PGI/Hospitality/?s=pano634',
      },
      {
        area: 'Grannys Poultry Basic Food Prep Lab',
        icon: culinary,
        lat: 49.898934,
        lng: -97.139837,
        link: 'https://www.rrctours.ca/PGI/Hospitality/?s=pano459',
      },
      {
        area: 'Garde Manger Lab',
        icon: culinary,
        lat: 49.898925,
        lng: -97.140079,
        link: 'https://www.rrctours.ca/PGI/Hospitality/?s=pano456',
      },
    ],
  },
  indigenousEducation: {
    name: 'Indigenous Education',
    icon: indigenousEducation,
    items: [
      {
        area: 'Indigenous Centre',
        icon: indigenousEducation,
        lat: 49.918631,
        lng: -97.212725,
        link: 'https://www.rrctours.ca/NDC/Indigenous_Supports/?s=pano1043',
      },
      {
        area: 'Medicine Wheel Garden',
        icon: indigenousEducation,
        lat: 49.92085,
        lng: -97.214422,
        link: 'https://www.rrctours.ca/NDC/Indigenous_Supports/?s=pano1045',
      },
    ],
  },
  skilledTrades: {
    name: 'Skilled Trades',
    icon: skilledTrades,
    items: [
      {
        area: 'Plumbing',
        icon: skilledTrades,
        lat: 49.91995,
        lng: -97.21033,
        link: 'https://www.rrctours.ca/NDC/Plumbing/?s=pano127',
      },
      {
        area: 'Refrigeration Lab',
        icon: skilledTrades,
        lat: 49.918566,
        lng: -97.208201,
        link: 'https://www.rrctours.ca/STTC/refrigeration/tour.html?startscene=0',
      },
      {
        area: 'Carpentry Shop',
        icon: skilledTrades,
        lat: 49.918563,
        lng: -97.207659,
        link: 'https://www.rrctours.ca/STTC/carpentry/tour.html?startscene=0',
      },
      {
        area: 'Carpentry Layout lab',
        icon: skilledTrades,
        lat: 49.918348,
        lng: -97.207664,
        link: 'https://www.rrctours.ca/STTC/carpentry/tour.html?startscene=3',
      },
      {
        area: 'Carpentry Drafting Lab',
        icon: skilledTrades,
        lat: 49.918348,
        lng: -97.207386,
        link: 'https://www.rrctours.ca/STTC/carpentry/tour.html?startscene=4',
      },
      {
        area: 'Storage Building',
        icon: skilledTrades,
        lat: 49.918798,
        lng: -97.207286,
        link: 'https://www.rrctours.ca/STTC/carpentry/tour.html?startscene=5',
      },
    ],
  },
  transportationTechnology: {
    name: 'Transportation Technology',
    icon: transportationTechnology,
    items: [
      {
        area: 'Hangar',
        icon: transportationTechnology,
        lat: 49.904109,
        lng: -97.251116,
        link: 'https://www.rrctours.ca/STE/?s=pano11',
      },
      {
        area: 'Heavy Duty Shop',
        icon: transportationTechnology,
        lat: 49.920094,
        lng: -97.208247,
        link: 'https://www.rrctours.ca/NDC/HETC/tour.html?startscene=0',
      },
      {
        area: 'Marine and Powersports Technician',
        icon: transportationTechnology,
        lat: 49.92019,
        lng: -97.20826,
        link: 'https://www.rrctours.ca/NDC/Powersports/tour.html?startscene=0',
      },
    ],
  },
};

const tourMarkerKeys = [
  'creativeArts',
  'culinary',
  'engineeringConstruction',
  'healthSciences',
  'indigenousEducation',
  'informationTechnology',
  'skilledTrades',
  'transportationTechnology',
];

// markers for toggle except the 'commonArea'
const nonTourMarkerKeys = Object.keys(markers).filter(
  (key) => ![...tourMarkerKeys, 'commonArea'].includes(key)
);

const tourMarkers = tourMarkerKeys.map((key) => ({
  key,
  name: markers[key].name,
  icon: markers[key].icon,
}));

const nonTourMarkers = nonTourMarkerKeys.map((key) => ({
  key,
  name: markers[key].name,
  icon: markers[key].icon,
}));

const getTour = (key, area) => {
  if (markers[key]) {
    if (area === 'default') {
      return markers[key].items[0];
    } else {
      return markers[key].items.find((item) => item.area === area);
    }
  }
};
// get all the areas under the same tour
const getAreas = (tour, area) => {
  // this only applies to common areas
  const campus = getTour(tour, area).campus;
  if (campus) {
    return markers[tour].items.filter((item) => item.campus === campus);
  } else {
    return markers[tour].items;
  }
};

export {
  markers,
  nonTourMarkers,
  tourMarkerKeys,
  tourMarkers,
  getTour,
  getAreas,
};
